import { render, staticRenderFns } from "./DmsRolesDetails.vue?vue&type=template&id=f2fcecb0"
import script from "./DmsRolesDetails.vue?vue&type=script&lang=js"
export * from "./DmsRolesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports